<template>
  <div ref="dialog" class="dialog-container" :class="dialogClass_">
    <el-dialog
      v-drag="dragComputed"
      :destroy-on-close="destroyOnClose"
      :custom-class="customClassComputed"
      :fullscreen="fullscreen"
      :title="title"
      :show-close="showClose"
      :visible.sync="visible"
      :before-close="beforeClose"
      :width="width"
      :top="top"
      :modal="modalComputed"
      :modal-append-to-body="modalAppendToBodyComputed"
      :append-to-body="fullscreen ? false : appendToBody"
      :lock-scroll="lockScroll"
      :center="center"
      :close-on-click-modal="closeOnClickModal"
      :close-on-press-escape="closeOnPressEscape"
      @opened="opened"
      @open="open"
      @close="close"
      @closed="closed"
    >
      <template slot="title">
        <slot name="title" />
      </template>
      <div
        v-if="$slots.leftBtn || $slots.rightBtn"
        ref="header-btn"
        v-resize="resetTableHeight"
        class="header-btn flexCB"
      >
        <template v-if="$slots.leftBtn">
          <div class="left-btn">
            <p><slot name="leftBtn" /></p>
            <cnd-icon
              v-if="fullscreen && fullControl"
              class="ml-8 pointer"
              :name="
                fullscreenEffect ? 'cnd-fullScreen-close' : 'cnd-fullScreen'
              "
              @click="setDialogPosition(fullscreenEffect ? 'close' : 'effect')"
            />
          </div>
        </template>
        <template v-if="$slots.rightBtn">
          <div class="right-btn">
            <slot name="rightBtn" />
          </div>
        </template>
      </div>
      <div
        :ref="!fullscreen ? 'reference' : ''"
        :class="{
          'dialog-body-position': fullscreen, // 详情页
          'dialog-ag-height': !fullscreen && !height, // 悬浮无高度
          flexV: !fullscreen
        }"
        :style="{
          'overflow-y': 'auto',
          top: fullscreenTop,
          height: fullscreen
            ? fullscreenTop
              ? `calc(100% - ${fullscreenTop})`
              : `100%`
            : initHeightComputed
        }"
      >
      <div v-if="closeOnClickModal" class="modal-block"/>
        <slot name="content" />
      </div>
      <template slot="footer">
        <slot name="footer" />
      </template>
    </el-dialog>
  </div>
</template>

<script>
import '../../../../lib/styles/components/Dialog.scss'
import analytics from '../../../utils/analytics'
export default {
  name: 'Dialog',
  props: {
    // close: {
    //   type: Function,
    //   default: () => {}
    // },
    // 是否显示
    visible: {
      type: Boolean,
      default: false
    },
    // 标题
    title: {
      type: String,
      default: ''
    },
    // 宽度
    width: {
      type: String,
      default: '50%'
    },
    // 是否为全屏 Dialog
    fullscreen: {
      type: Boolean,
      default: true
    },
    // 弹窗 margin-top 值
    top: {
      type: String,
      default: '15vh'
    },
    // 是否需要遮罩层
    modal: {
      type: Boolean,
      default: true
    },
    // 遮罩层是否插入至 body 元素上，若为 false，则遮罩层会插入至 Dialog 的父元素上
    modalAppendToBody: {
      type: Boolean,
      default: true
    },
    // Dialog 自身是否插入至 body 元素上。嵌套的 Dialog 必须指定该属性并赋值为 true
    appendToBody: {
      type: Boolean,
      default: true
    },
    // 是否在 Dialog 出现时将 body 滚动锁定
    lockScroll: {
      type: Boolean,
      default: true
    },
    // 自定义类名
    className: {
      type: String,
      default: ''
    },
    // 是否可以通过点击 modal 关闭 Dialog
    closeOnClickModal: {
      type: Boolean,
      default: true
    },
    // 是否可以通过按下 ESC 关闭 Dialog
    closeOnPressEscape: {
      type: Boolean,
      default: true
    },
    // 是否显示关闭按钮
    showClose: {
      type: Boolean,
      default: true
    },
    // 关闭前的回调，会暂停 Dialog 的关闭
    // beforeClose: {
    //   type: Function,
    //   default: () => {}
    // },
    // 是否对头部和底部采用居中布局
    center: {
      type: Boolean,
      default: false
    },
    // 关闭时销毁 Dialog 中的元素
    destroyOnClose: {
      type: Boolean,
      default: false
    },
    // 不明生物
    // fixedHeader: {
    //   type: Boolean,
    //   default: true
    // },
    drag: {
      type: String,
      default: 'all' // 'all'、'move'、'zoom'
    },
    height: {
      type: [String, Number],
      default: ''
    },
    autoZoom: {
      type: Boolean,
      default: false
    },
    // 高度为插槽元素高度
    enabledSlotHeight: {
      type: Boolean,
      default: true
    },
    // 初始状态是否全屏，在fullscreen为true时有效
    fullOpend: {
      type: Boolean,
      default: false
    },
    // 全屏按钮显示/隐藏，在fullscreen为true时有效
    fullControl: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      timeout: null,
      isOpened: true,
      fullscreenEffect: false,
      flagZoom: false,
      fullscreenTop: 0,
      dialogShowTime: 0,
      slotHeight: 0,
      fullPath: '', // 记录当前页面路径
      preFullscreenEffect: false // 离开前的状态
    }
  },
  computed: {
    dialogClass_() {
      const dialogDetailsState = this.getEditState() // 编辑状态
      // const sidebarList = document.getElementsByClassName('sidebar-container')
      // const sidebarWidth = 180
      // if (sidebarList && sidebarList.length > 0) {
      //   sidebarWidth = sidebarList[0].clientWidth
      // }
      return {
        'mark-class': this.fullscreen,
        // 'full-screen-opened': sidebarWidth > 180 && !this.fullscreenEffect, // 打开菜单栏时候的样式
        // 'full-screen-closed': sidebarWidth <= 180 && !this.fullscreenEffect, // 收起菜单栏时候的样式
        'full-screen-opened': this.fullscreenEffect, // 打开菜单栏时候的样式
        'full-screen-closed': !this.fullscreenEffect, // 收起菜单栏时候的样式
        'details-state-disable': !dialogDetailsState // details-state-disable 为不可编辑样式
      }
    },
    initHeightComputed() {
      console.log('this.height', this.height)
      if (this.fullscreen || !this.height || this.height === 'auto') {
        return 'auto'
      }
      if (Number.isFinite(Number(this.height))) return `${this.height}px`
      return this.height
    },
    // initHeightComputed(e) {
    //   // 如果传入height 就使用height ，并且移除了props.height 的500 默认值
    //   // 若没有传入height 则使用计算的slotheight
    //   let height = this.height
    //   if (this.fullscreen || this.height === "auto") {
    //     return "auto"
    //   }
    //   if (
    //     this.slotHeight &&
    //     Number.isFinite(Number(this.slotHeight)) &&
    //     this.enabledSlotHeight
    //   ) {
    //     if (this.slotHeight > height || !height) {
    //       return `${this.slotHeight}px`
    //     }
    //   }
    //   if (height && Number.isFinite(Number(height))) {
    //     return `${height}px`
    //   }
    //   console.log("dialog-height", height)
    //   return height
    // },
    customClassComputed() {
      const className = `dialog-wrap ${
        this.fullscreen ? '' : 'suspended-dialog'
      } ${this.autoZoomComputed ? 'zoom' : ''} ${
        this?.$slots?.footer ? '' : 'no-footer'
      } ${this.className}`
      return className
    },
    modalAppendToBodyComputed() {
      if (this.fullscreen) return false
      return this.modalAppendToBody
    },
    modalComputed() {
      if (this.fullscreen) return false
      return this.modal
    },
    dragComputed() {
      if (this.fullscreen) return 'none'
      return this.drag
    },
    autoZoomComputed() {
      if ((this.height && this.height !== 'auto') || this.slotHeight) {
        return true
      }
      return this.autoZoom
    }
  },
  watch: {
    visible(value) {
      const that = this
      that.setDialogTime(value)
      if (value) {
        try {
          const analyticsInstance = analytics.getAnalyticsInstance(that)
          analyticsInstance.reportEvent('dialog_show', {
            dialog_name: that.title
          })
        } catch (e) {
          console.log(e)
        }
        if (this.enabledSlotHeight) {
          // 获取插槽元素高度
          this.getContentSlotHeight()
        }
      }
    },
    $route(to, from) {
      if (!this.fullscreen) return
      // 回到当前页
      // if (
      //   to.fullPath === this.fullPath &&
      //   this.fullOpend &&
      //   this.preFullscreenEffect
      // ) {
      //   this.setDialogPosition('effect')
      // }

      // // 从当前页离开的记录最后状态
      // if (from.fullPath === this.fullPath) {
      //   this.preFullscreenEffect = this.fullscreenEffect
      //   // 如果时全屏状态则还原
      //   if (this.fullscreenEffect) {
      //     this.setDialogPosition()
      //   }
      // }
    }
  },
  created() {
    // 记录当前页面地址
    this.fullPath = this.$route.fullPath
    // this.resetTableHeight()
  },
  mounted() {
    if (this.fullscreen && this.fullOpend) {
      this.setDialogPosition('effect')
    } else {
      // 为init状态的时候不移除 full-screen-opened 属性，防止内部嵌套dialog导致full-screen-opened属性被移除
      this.setDialogPosition('init')
    }
    // 监听菜单展开 / 收起事件
    // window.addEventListener(
    //   'menuResize',
    //   this.debounce((ev) => {
    //     const fullDialogList = Array.from(
    //       document.getElementsByClassName('mark-class')
    //     )
    //     this.isOpened = ev.detail.isOpened
    //     fullDialogList.length > 0 &&
    //       fullDialogList.forEach((dom) => {
    //         const navbarEl = document.querySelectorAll(
    //           '.navbar-banner'
    //         )[0]
    //         const isFull = ['full-screen-opened', 'full-screen-closed'].some(
    //           (v) => navbarEl.hasAttribute(v)
    //         )
    //         if (isFull) return
    //         if (this.isOpened) {
    //           dom.classList.add('full-screen-opened')
    //           dom.classList.remove('full-screen-closed')
    //         } else {
    //           dom.classList.remove('full-screen-opened')
    //           dom.classList.add('full-screen-closed')
    //         }
    //       })
    //   }, 10),
    //   false
    // )
    // 监听弹框缩放事件
    window.addEventListener('dialogResize', this.dResizeHandlder)
    window.addEventListener('dialogOnmouseup', this.dOnmouseupHandlder)
  },
  methods: {
    // Dialog 打开的回调
    open() {
      this.$emit('open')
    },
    // Dialog 打开动画结束时的回调
    opened() {
      this.$emit('opened')
    },
    // Dialog 关闭的回调
    close() {
      this.$emit('close')
    },
    // Dialog 关闭动画结束时的回调
    closed() {
      this.$emit('closed')
    },
    getContentSlotHeight() {
      this.$nextTick(() => {
        if (this.$slots.content && this.$slots.content.length >= 1) {
          // 获取slot content的元素高度
          let num = 0
          this.$slots.content.forEach((item) => {
            num += item.elm.clientHeight
          })
          this.slotHeight = num
        }
        // 若获取不到高度，例如content slot 为 el-form 由于form-item组件原因高度塌陷
        // 则使用slot 外层div的高度
        if (!this.slotHeight) {
          const h =
            this.$refs.reference.clientHeight ||
            this.$refs.reference.scrollHeight
          this.slotHeight = h || 0
        }
      })
    },
    resetTableHeight() {
      this.fullscreenTop = this.$refs['header-btn']
        ? this.$refs['header-btn'].offsetHeight + 10 + 'px'
        : 0
      console.log(
        'fullscreenTop',
        this.$refs['header-btn'].offsetHeight,
        this.fullscreenTop
      )
    },
    setDialogPosition(type = '') {
      const navbarEl = document.querySelectorAll('.navbar-banner')[0]
      const navbarLogo = document.querySelectorAll('.sidebar-logo')[0]
      if (type === 'effect') {
        this.fullscreenEffect = true
        // 用于判断当前是否处于全屏
        navbarEl.setAttribute('full-screen-opened', true)
        navbarLogo.setAttribute('full-screen-opened', true)
      } else {
        this.fullscreenEffect = false
        if (type !== 'init') {
          navbarEl.removeAttribute('full-screen-opened')
          navbarLogo.removeAttribute('full-screen-opened')
        }
      }
    },
    beforeClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    // 防抖debounce代码：
    debounce(fn, delay) {
      this.timeout = null // 创建一个标记用来存放定时器的返回值
      return function(e) {
        // 每当用户输入的时候把前一个 setTimeout clear 掉
        this.timeout && clearTimeout(this.timeout)
        // 然后又创建一个新的 setTimeout, 这样就能保证interval 间隔内如果时间持续触发，就不会执行 fn 函数
        this.timeout = setTimeout(() => {
          fn.apply(this, arguments)
        }, delay)
      }
    },
    dResizeHandlder(myEvent) {
      this.flagZoom = true
      console.log('dResizeHandlder-----', myEvent)
      window.removeEventListener('dialogResize', this.dResizeHandlder)
    },
    dOnmouseupHandlder(myEvent) {
      console.log('dOnmouseupHandlder----', myEvent)
    },
    // 获得弹窗打开时间
    setDialogTime(value) {
      if (!value) {
        const that = this
        const duration = new Date().getTime() - this.dialogShowTime
        try {
          const analyticsInstance = analytics.getAnalyticsInstance(that)
          analyticsInstance.reportEvent('dialog_operate_time_cost', {
            dialog_name: that.title,
            operate_time_cost: duration
          })
        } catch (e) {
          console.log(e)
        }
      } else {
        this.dialogShowTime = new Date().getTime()
      }
    },
    // 获取编辑状态
    getEditState() {
      // 获取路由传递参数edit和 sessionStorage 中设置的编辑状态 来初始化设置编辑状态
      // sessionStorage中值优先
      const { edit = 'true' } = this.$route.query
      let visitedViews = []
      try {
        visitedViews = JSON.parse(sessionStorage.getItem('visitedViews')) || []
      } catch (error) {
        console.log(error)
      }
      const visite =
        visitedViews.find(
          (v) => v.fullPath && v.fullPath.indexOf(this.$route.fullPath) !== -1
        ) || {}
      const dialogEdit = visite.dialogEdit || edit
      return eval(dialogEdit)
    }
  }
}
</script>
